import React from 'react';
import Layout from '../common/layouts';
import InvestorIntakeForm from '../components/investorIntakeForm';

export default (props) => (
  <Layout>
    <div class="mw9 center ph3-ns">
      <div class="cf ph2-ns">
        <div class="fl w-100 w-50-ns">
          <img
            width="700"
            alt="a placeholder"
            src="https://placeimg.com/500/500/arch?t=1588820441463"
          />
        </div>
        <div class="fl w-100 w-50-ns pa3 bg-light-gray ">
          <InvestorIntakeForm />
        </div>
      </div>
    </div>
  </Layout>
);
